import cloneDeep from 'lodash.clonedeep';
import jseu from 'js-encoding-utils';

/**
 * JWT class
 */
class JWT {
  header: any;
  payload: any;
  signature: any;
  b64uString: string;

  constructor() {
    this.header = {};
    this.payload = {};
    this.signature = new Uint8Array([]);
    this.b64uString = '';
  }

  /**
   * setter of b64uString start from here
   * @param b64uString b64u文字列
   */
  set setB64uString(b64uString: string) {
    const tokenArray = b64uString.split('.');
    if (tokenArray.length !== 3) throw new Error('Invalid Token');
    const decoded: any = tokenArray.map((x) => jseu.encoder.decodeBase64Url(x));

    if (decoded[0] instanceof Uint8Array) {
      this.header = JSON.parse(new TextDecoder().decode(decoded[0]));
    } else {
      this.header = JSON.parse(decoded[0]);
    }

    if (decoded[1] instanceof Uint8Array) {
      this.payload = JSON.parse(new TextDecoder().decode(decoded[1]));
    } else {
      this.payload = JSON.parse(decoded[1]);
    }
    this.signature = decoded[2];
    this.b64uString = cloneDeep(b64uString);
  }

  set setHeader(headerObj: { [name: string]: string }) {
    if (!headerObj.kid) throw new Error('Invalid Token Header');
    this.header = cloneDeep(headerObj);
  }

  set setPayload(payloadObj: any) {
    this.payload = cloneDeep(payloadObj);
  }

  set setSignature(signatureBuffer: Uint8Array) {
    this.signature = cloneDeep(signatureBuffer);
  }

  get getHeader() {
    return cloneDeep(this.header);
  }

  get getPayload() {
    return cloneDeep(this.payload);
  }

  get getSignature() {
    return cloneDeep(this.signature);
  }

  get getB64uString() {
    return cloneDeep(this.b64uString);
  }
}

/**
 * parse JWT
 * @param token {string}
 * @returns JWR Class
 */
export const parseJwt = (token: string): JWT => {
  const jwt: JWT = new JWT();
  jwt.setB64uString = token;
  return jwt;
};

/**
 * Get your userId from token
 * @param token {string}
 * @returns parsedToken.payload['cognito:username']
 */
export const getUserIdFromToken = (token: string): string | undefined => {
  // 0a: parse token and get userId
  const parsedToken: JWT = parseJwt(token);
  if (
    // eslint-disable-next-line no-prototype-builtins
    typeof parsedToken.payload === 'undefined' ||
    !typeof parsedToken.payload.hasOwnProperty('cognito:username')
  ) {
    return undefined;
  }
  return parsedToken.payload['cognito:username'];
};

/**
 * Get your email from token
 * @param token {string}
 * @returns parsedToken.payload.email
 */
export const getEmailFromToken = (token: string): string | undefined => {
  // 0a: parse token and get userId
  const parsedToken = parseJwt(token);
  if (
    typeof parsedToken.payload === 'undefined' ||
    // eslint-disable-next-line no-prototype-builtins
    !parsedToken.payload.hasOwnProperty('email')
  ) {
    return undefined;
  }
  return parsedToken.payload.email;
};

/**
 * Get the whole payload in token
 * @param token {string}
 * @returns parsedToken.payload
 */
export const getAllPayload = (token: string): string | undefined => {
  // 0a: parse token and get userId
  const parsedToken = parseJwt(token);
  if (typeof parsedToken.payload === 'undefined') {
    return undefined;
  }
  return parsedToken.payload;
};
